import { Grid } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import {GRID_DEFAULT_TEXT} from "../../../other/configs/globalConfig.jsx";
import { getGridLinesPreferenceSetting, getRowHeight, userPreferences } from "../../../react/context/bryntumContext.jsx";
import { getGridRowHeight } from "../../../other/utils/utils.jsx";

export class SwivuPreferenceStyleGrid extends Grid {
  static get $name() {
    return "SwivuPreferenceStyleGrid";
  }

  static get type() {
    return WIDGET_KEYS.swivuPreferenceStyleGrid;
  }

  static get configurable() {
    return {
      ...super.configurable,
      emptyText: GRID_DEFAULT_TEXT,
      features: {
        sort: { multiSort: false },
        stripe: { disabled: true }
      },
      getRowHeight: getGridRowHeight,
      rowLines: false
    };
  }

  construct(...args) {
    /* Applying paint listener here instead of passing in config because bryntum is overwriting our listener config with the mixins config, hence listeners in the config are not working so we are applying paint listener here.
    Also calling super.construct after assigning listener to the widget is necessary because react widgets are neglecting listener if we construct before assigning listener. */
    this.on("paint", this.applyGridGlobalSettings, this);
    super.construct(...args);
  }

  applyGridGlobalSettings() {
    if (userPreferences) {
      /* Apply base settings on widget paint */
      const swivuAdditionalRowHeight = this.swivuAdditionalRowHeight || 0;
      if (this.features.stripe) this.features.stripe.disabled = !(userPreferences.getSetting("stripeFeature") === String(true))
      this.rowHeight = getRowHeight() + swivuAdditionalRowHeight;
      this.rowLines = getGridLinesPreferenceSetting();
      if (this.onRowLinesChange) this.onRowLinesChange(this.rowLines);
      /* Handle widget ui on change of user preferences */
      userPreferences.on(
        "change",
        ({ record }) => {
          /* Handle stripe feature */
          if (this.features.stripe && record?.key === "stripeFeature") this.features.stripe.disabled = !(record.value === String(true));
          /* Handle row height size based on font size */
          if (["viewType", "fontSize"].includes(record?.key)) {
            this.rowHeight = getRowHeight() + swivuAdditionalRowHeight;
            if (!this.reactComponent) {
              this.refreshHeaders();
              this.refreshRows()
            }; // Refresh rows & headers to apply the new row height, In expandable rows if we dont refresh the rows it messes up the UI of rows
          };
          /* Handle row grid lines */
          if (record?.key === "gridlines") {
            this.rowLines = record.value === String(true);
            if (this.onRowLinesChange) this.onRowLinesChange(this.rowLines);
          };
        },
        this
      );
    }
  }
}
